import { css } from 'styled-components';
import { rem } from '../../../helpers/mixins';
import { PINK, PURPLE_LIGHT, YELLOW } from '../../../constants/colors';

export default {
  wrapper: ({ disableButton }) => css`
  margin-top: 48px;
  padding-top: 100px;
  padding-bottom: 100px;
`,
  title: css`
  font-size: ${rem(24)};
  margin-bottom: 30px;
  color: ${PURPLE_LIGHT};
`,
  content: css`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
`,
  fieldGroup: css`
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`,
  fieldText: css`
  border: 0;
  width: 100%;
  border-bottom: 1px solid #000;
`,
  fieldLabel: css`
  font-size: ${rem(10)};
`,
  messageBox: css`
  background-color: ${YELLOW};
  padding: 8px 32px;
  margin-bottom: 30px;
  border-radius: 5px;
`,
  continue: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 100px;
    height: 32px;
    background-color: ${PINK};
  `,
};
